import { useRequesterStore } from '../stores/requester'
import type { SaveFundPayload } from '../types/fund'

let requesterX: any

export async function saveFund(body: SaveFundPayload) {
  requesterX = requesterX ? requesterX : useRequesterStore()
  return requesterX.Post({
    route: '/fund/create',
    withAuth: true,
    body,
  })
}

export async function getAllFunds() {
  requesterX = requesterX ? requesterX : useRequesterStore()
  return requesterX.Get({
    route: '/fund',
    withAuth: true,
  })
}

export async function setFundStatus(id: number, status: 'open' | 'closed') {
  requesterX = requesterX ? requesterX : useRequesterStore()
  return requesterX.Put({
    route: '/fund/status',
    withAuth: true,
    body: { id, status },
  })
}

export async function deleteFund(id: number) {
  requesterX = requesterX ? requesterX : useRequesterStore()
  return requesterX.Delete({
    route: `/fund/delete/${id}`,
    withAuth: true,
  })
}
